export const EMAIL =
  /^(([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|("[^"\\\x80-￿]+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const NON_BE_PHONE = /^[+]?[0-9]{1,4}?[0-9]{6,15}$/
export const BE_PHONE = /^[+]?[0-9]{2}?[0-9]{7,9}$/
export const POSTAL_CODE = /[0-9]*/
export const LETTERS_NUMBERS_SLASHES_DASHES = /^[a-zA-Z0-9/-]*$/
export const BELGIAN_ENTERPRISE_NUMBER = /^[0-9]{10}$/
